import { api } from './client'
import type { AuthResponse, RegisterResponse, SessionResponse } from './types'

export interface LoginParams {
  email: string
  password: string
  slug?: string
}

export interface RegisterParams {
  agencyName: string
  slug: string
  fullName: string
  email: string
  password: string
}

export interface WorkspaceOption {
  slug: string
  name: string
}

/** Workspaces an email+password can sign into — for the login picker on multi-workspace emails. */
export async function fetchWorkspaces(email: string, password: string): Promise<WorkspaceOption[]> {
  const { data } = await api.post<WorkspaceOption[]>('/api/auth/workspaces', { email, password })
  return data
}

/** Current identity, read fresh from the server (no tokens) — used to refresh the stored session. */
export async function getSession(): Promise<SessionResponse> {
  const { data } = await api.get<SessionResponse>('/api/auth/me')
  return data
}

export async function login(params: LoginParams): Promise<AuthResponse> {
  const { data } = await api.post<AuthResponse>('/api/auth/login', params)
  return data
}

export async function register(params: RegisterParams): Promise<RegisterResponse> {
  const { data } = await api.post<RegisterResponse>('/api/auth/register', params)
  return data
}

export async function verifyEmail(token: string): Promise<void> {
  await api.post('/api/auth/verify', { token })
}

export async function forgotPassword(email: string, slug?: string): Promise<void> {
  await api.post('/api/auth/forgot-password', { email, slug: slug?.trim() || undefined })
}

export async function resetPassword(token: string, password: string): Promise<void> {
  await api.post('/api/auth/reset-password', { token, password })
}

export async function unsubscribeEmail(token: string): Promise<void> {
  await api.post('/api/email/unsubscribe', { token })
}

export async function resubscribeEmail(token: string): Promise<void> {
  await api.post('/api/email/resubscribe', { token })
}
